import HeaderSection from '../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../components/CockpitCards/CardTransparent';


export default function BioAgeText() {

    
    return (

<CardTransparent content = {
        
        <HeaderSection

            headline_p1 = "Start with medicine's key question: How old are really? " 
            headline_grey = "How fast are you aging?"
            headline_p2 = ""

            text1 = "Both chronological age and biological age are ways of measuring aging and how the passage of time impacts the body. While chronological age is simply how long you've been alive, biological age reflects how well your body has aged on a cellular and physiological level."
            text2 = "Bio clocks reflect both epigenetic and proteomic algorithms."

        />
    }/>
            
  )
}